export default {
    async call(url, options) {
      const response = await fetch(url, options);
      if (response.ok) {
        const text = await response.text();
        if (text) {
          return JSON.parse(text);
        }
        else {
          return null;
        }
      }
      await this.handleError(response);
    },
    async handleError(response) {
      switch (response.status) {
        case 400: {
          const error = await response.json();
          if (error) {
            throw new Error(`${error.title} [${response.status}]: ${error.message}`);
          }
          throw new Error(`${response.status}: Server Error`);
        }
        case 401: 
          throw new Error(`${response.status}: Unathorized`);
        case 500:
          throw new Error(`${response.status}: Internal Server Error`);
        default:
          throw new Error(`${response.status}: Server Error`);
      }
    }
  }